import React from "react";
import Joi from "joi-browser";
import FormState from "./common/formstate";
import ReCAPTCHA from "react-google-recaptcha";
import { saveIssue } from "../services/supportIssuesService";
import "./supportForm.css";
import { apiUrl } from "../config.json";

const encode = (data) => {
	return Object.keys(data)
		.map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
		.join("&");
};

class SupportForm extends FormState {
	state = {
		data: {
			first_name: "",
			last_name: "",
			email: "",
			message: "",
			status: "RECEIVED",
		},
		errors: {},
		isRecaptchaVerified: false,
	};

	schema = {
		first_name: Joi.string().required().label("First Name").max(50),
		last_name: Joi.string().required().label("Last Name").max(50),
		email: Joi.string().required().label("Email").max(150).email(),
		message: Joi.string().required().label("Message").max(500),
		status: Joi.string().required().label("Status").max(45),
	};

	async componentDidMount() {}

	handleRecaptchaChange = (value) => {
		// This function will be called when reCAPTCHA is verified
		this.setState({
			isRecaptchaVerified: true,
		});
	};

	async doSubmit() {
		if (this.state.isRecaptchaVerified) {
			const { data: issue } = this.state;
			const result = await saveIssue(issue);

			// if (result.id) {
			// 	this.props.history.push("/success");
			// }
			const url = apiUrl + "/issues";
			const data = encode({ "form-name": "support-issues", ...issue });

			console.info(data);
			fetch("/", {
				method: "POST",
				headers: { "Content-Type": "application/x-www-form-urlencoded" },
				body: data,
			})
				.then(() => {
					this.props.history.push("/success");
				})
				.catch((error) => alert(error));
		}
	}

	render() {
		return (
			<>
				<div className="supportFormContainer">
					<h3>Contact Us</h3>
					<br />
					<form onSubmit={this.handleSubmit}>
						<table className="supportFormTable">
							<tbody>
								<tr>
									<td width="100%">
										{this.renderInput("first_name", "First Name", "pencil-alt")}
									</td>
								</tr>
								<tr>
									<td width="100%">
										{this.renderInput("last_name", "Last Name", "pencil-alt")}
									</td>
								</tr>
								<tr>
									<td width="100%">
										{this.renderInput("email", "Email", "pencil-alt")}
									</td>
								</tr>
								<tr>
									<td width="100%">
										{this.renderTextarea(
											"message",
											"Message (1000 characters)",
											"pencil-alt",
											"black",
											"message",
											5,
											40
										)}
									</td>
								</tr>
								<tr>
									<td>
										<ReCAPTCHA
											sitekey={process.env.REACT_APP_SITE_KEY}
											onChange={this.handleRecaptchaChange}
										/>
									</td>
								</tr>
								<tr>
									<td>
										<button className="btn btn-primary">Submit</button>&nbsp;
									</td>
								</tr>
							</tbody>
						</table>
					</form>
				</div>
			</>
		);
	}
}

export default SupportForm;
